export default __webpack_public_path__ + "static/media/16_externallink.8e994372.svg";